(() => {
  const APP_ROOT = '.reelUp_playlist_slider_static.reelUp_carousel';
  const CARD = '.reelUp_slide';
  const HEADING = '.reelUp_slider_heading';
  const SETTLE_DELAY = 150;
  const WATCH_TIMEOUT = 20000;

  const built = new WeakSet();
  const products = new Map();

  const currentScript = document.currentScript;
  const swiperSrc = currentScript ? currentScript.dataset.swiperSrc : '';
  let swiperPromise = null;
  let observer = null;
  let settleTimer = 0;

  const NAV_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  const CART_ICON =
    '<svg viewBox="0 0 19 18" fill="none" aria-hidden="true" focusable="false" ' +
    'stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M5.61107 10.3418H16.6215L17.9751 2.70703H4.09375L5.61107 10.3418Z"/>' +
    '<path d="M5.48438 9.64648L6.06546 12.4228H16.5895"/>' +
    '<path d="M4.09534 2.7072L3.27679 0.625H0.625"/>' +
    '<path d="M14.6133 16.9669C15.2929 16.9669 15.8438 16.416 15.8438 15.7364C15.8438 15.0568 ' +
    '15.2929 14.5059 14.6133 14.5059C13.9337 14.5059 13.3828 15.0568 13.3828 15.7364C13.3828 ' +
    '16.416 13.9337 16.9669 14.6133 16.9669Z"/>' +
    '<path d="M8.293 16.9669C8.97259 16.9669 9.52351 16.416 9.52351 15.7364C9.52351 15.0568 ' +
    '8.97259 14.5059 8.293 14.5059C7.61342 14.5059 7.0625 15.0568 7.0625 15.7364C7.0625 ' +
    '16.416 7.61342 16.9669 8.293 16.9669Z"/>' +
    '</svg>';

  function ensureSwiper() {
    if (typeof window.Swiper !== 'undefined') return Promise.resolve();
    if (swiperPromise) return swiperPromise;

    swiperPromise = new Promise((resolve, reject) => {
      if (document.querySelector('script[src*="swiper-bundle"]')) {
        let attempts = 60;
        const poll = () => {
          if (typeof window.Swiper !== 'undefined') resolve();
          else if (attempts-- <= 0) reject(new Error('Swiper never became available'));
          else window.setTimeout(poll, 50);
        };
        poll();
        return;
      }
      if (!swiperSrc) {
        reject(new Error('Missing data-swiper-src'));
        return;
      }
      const el = document.createElement('script');
      el.src = swiperSrc;
      el.addEventListener('load', () => resolve());
      el.addEventListener('error', () => reject(new Error('Failed to load Swiper')));
      document.head.appendChild(el);
    });

    return swiperPromise;
  }

  const money = (cents) => {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.shopCurrency || 'USD',
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  function fetchProduct(handle) {
    if (products.has(handle)) return products.get(handle);
    const request = fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);
    products.set(handle, request);
    return request;
  }

  function playlist(appRoot) {
    const videos = (window.REELUP && window.REELUP.videos) || [];
    const byId = new Map(videos.map((video) => [String(video.id), video]));

    return Array.from(appRoot.querySelectorAll(CARD))
      .map((card) => {
        const reelId = card.dataset.reelId;
        const video = byId.get(String(reelId));
        if (!video || !video.short_video) return null;
        const handle = card.dataset.productHandle;
        return {
          reelId,
          title: video.title || '',
          video: video.short_video,
          poster: video.thumbnail || '',
          handle: handle && handle !== 'null' ? handle : null,
        };
      })
      .filter(Boolean);
  }

  function bringIntoView(el) {
    let node = el.parentElement;
    while (node) {
      const { overflowX } = window.getComputedStyle(node);
      if (overflowX === 'scroll' || overflowX === 'auto') {
        const scroller = node.getBoundingClientRect();
        const card = el.getBoundingClientRect();
        node.scrollLeft += card.left - scroller.left - (node.clientWidth - card.width) / 2;
        return;
      }
      node = node.parentElement;
    }
  }

  function fireSequence(target, clientX, clientY) {
    ['pointerover', 'pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach((type) => {
      const Ctor = type.startsWith('pointer') && window.PointerEvent ? window.PointerEvent : MouseEvent;
      target.dispatchEvent(
        new Ctor(type, {
          bubbles: true,
          cancelable: true,
          composed: true,
          view: window,
          clientX,
          clientY,
          button: 0,
          buttons: type.endsWith('down') ? 1 : 0,
          pointerId: 1,
          pointerType: 'mouse',
          isPrimary: true,
          detail: 1,
        })
      );
    });
  }

  function cartHost() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function smartCart() {
    const cart = window.Rebuy && window.Rebuy.SmartCart;
    return cart && typeof cart.show === 'function' ? cart : null;
  }

  function renderCartBubble(response) {
    const html = response.sections && response.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;

    const rendered = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.shopify-section');
    if (rendered) bubble.innerHTML = rendered.innerHTML;
  }

  function openSmartCart(cart) {
    fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((data) => {
        if (typeof cart.setCart === 'function') cart.setCart(data);
      })
      .catch(() => {})
      .finally(() => cart.show());
  }

  function addToCart(button) {
    if (button.disabled || !button.dataset.variantId) return;

    const host = cartHost();
    const drawer = smartCart();
    const sections = drawer
      ? ['cart-icon-bubble']
      : (host && host.getSectionsToRender().map((section) => section.id)) || [];

    const body = new FormData();
    body.append('id', button.dataset.variantId);
    body.append('quantity', '1');
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    button.disabled = true;
    button.classList.remove('reelup-carousel__cart--failed');

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'reelup-carousel',
            productVariantId: button.dataset.variantId,
            cartData: response,
          });
        }

        if (drawer) {
          renderCartBubble(response);
          openSmartCart(drawer);
          return;
        }

        if (host) {
          host.setActiveElement(button);
          host.renderContents(response);
          return;
        }

        window.location = window.routes.cart_url;
      })
      .catch((error) => {
        console.warn('[reelup]', error);
        button.classList.add('reelup-carousel__cart--failed');
      })
      .finally(() => {
        button.disabled = false;
      });
  }

  function openInApp(appRoot, reelId) {
    const card = appRoot.querySelector(`${CARD}[data-reel-id="${reelId}"]`);
    if (!card) return;

    bringIntoView(card);

    appRoot.style.setProperty('pointer-events', 'auto', 'important');
    appRoot.style.setProperty('z-index', '2', 'important');

    const inner = card.querySelector('.reelUp_card') || card;
    const box = inner.getBoundingClientRect();

    if (box.width && box.height) {
      const vw = document.documentElement.clientWidth;
      const vh = document.documentElement.clientHeight;
      const left = Math.max(box.left, 0);
      const top = Math.max(box.top, 0);
      const right = Math.min(box.right, vw);
      const bottom = Math.min(box.bottom, vh);
      const onScreen = right > left && bottom > top;

      const clientX = Math.round(onScreen ? (left + right) / 2 : box.left + box.width / 2);
      const clientY = Math.round(onScreen ? (top + bottom) / 2 : box.top + box.height / 2);

      const atPoint = document.elementFromPoint(clientX, clientY);
      const target = atPoint && inner.contains(atPoint) ? atPoint : inner;
      fireSequence(target, clientX, clientY);
    }

    window.setTimeout(() => {
      appRoot.style.removeProperty('pointer-events');
      appRoot.style.removeProperty('z-index');
    }, 250);
  }

  function silence(appRoot) {
    appRoot.querySelectorAll('video').forEach((video) => {
      if (video.dataset.reelupSilenced) return;
      video.dataset.reelupSilenced = 'true';
      video.muted = true;
      video.removeAttribute('autoplay');
      video.addEventListener('play', () => video.pause());
      video.pause();
    });
  }

  function spacing(wrap) {
    const value = parseFloat(window.getComputedStyle(wrap).getPropertyValue('--reelup-gap'));
    return Number.isFinite(value) ? value : 15;
  }

  function fitsOnScreen(container, track, gap, wrap) {
    const probe = document.createElement('div');
    probe.className = 'swiper-slide reelup-carousel__slide';
    track.appendChild(probe);
    const slot = probe.getBoundingClientRect().width + gap;
    probe.remove();

    const room = container.clientWidth;
    const fallback = parseFloat(window.getComputedStyle(wrap).getPropertyValue('--reelup-visible'));
    let count =
      slot > 0 && room > 0 ? Math.ceil(room / slot) : Math.ceil(fallback || 4.5);
    if (count % 2 === 0) count += 1;
    return count;
  }

  function resize() {
    document.querySelectorAll('.reelup-carousel__swiper').forEach((container) => {
      const swiper = container.swiper;
      const wrap = container.closest('.reelup-carousel');
      if (!swiper || !wrap) return;

      const next = spacing(wrap);
      if (next !== swiper.params.spaceBetween) {
        swiper.params.spaceBetween = next;
        swiper.update();
      }
    });
  }

  function slideMarkup(entry) {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide reelup-carousel__slide';
    slide.dataset.reelId = entry.reelId;

    const card = document.createElement('div');
    card.className = 'reelup-carousel__card';
    slide.appendChild(card);

    const media = document.createElement('video');
    media.className = 'reelup-carousel__video';
    media.src = entry.video;
    if (entry.poster) media.poster = entry.poster;

    media.setAttribute('muted', '');
    media.setAttribute('loop', '');
    media.setAttribute('playsinline', '');
    media.setAttribute('preload', 'none');
    media.muted = true;

    media.setAttribute('aria-label', entry.title.slice(0, 120));
    card.appendChild(media);

    return slide;
  }

  function pickVariant(product) {
    const first = product && product.variants && product.variants[0];
    return first && first.available ? first : null;
  }

  function cartControl(product) {
    const variant = pickVariant(product);
    const url = product.url || `/products/${product.handle}`;

    if (!variant) {
      const link = document.createElement('a');
      link.className = 'reelup-carousel__cart';
      link.href = url;
      link.setAttribute('aria-label', product.title);
      link.innerHTML = CART_ICON;
      return link;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'reelup-carousel__cart';
    button.dataset.variantId = variant.id;
    button.setAttribute('aria-label', `Add ${product.title} to cart`);
    button.innerHTML = CART_ICON;
    return button;
  }

  function attachProduct(slide, product) {
    if (!product || slide.querySelector('.reelup-carousel__product')) return;

    const bar = document.createElement('div');
    bar.className = 'reelup-carousel__product';

    const image = product.featured_image || (product.images && product.images[0]);
    if (image) {
      const thumb = document.createElement('img');
      thumb.className = 'reelup-carousel__thumb';
      thumb.src = `${image}${image.includes('?') ? '&' : '?'}width=120`;
      thumb.alt = '';
      thumb.loading = 'lazy';
      bar.appendChild(thumb);
    }

    const text = document.createElement('div');
    text.className = 'reelup-carousel__text';

    const name = document.createElement('span');
    name.className = 'reelup-carousel__name';
    name.textContent = product.title;
    text.appendChild(name);

    const price = document.createElement('span');
    price.className = 'reelup-carousel__price';
    price.textContent = money(product.price);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      const was = document.createElement('s');
      was.className = 'reelup-carousel__compare';
      was.textContent = money(product.compare_at_price);
      price.appendChild(was);
    }
    text.appendChild(price);
    bar.appendChild(text);

    bar.appendChild(cartControl(product));

    (slide.querySelector('.reelup-carousel__card') || slide).appendChild(bar);
  }

  function playOnly(swiper) {
    swiper.slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (index === swiper.activeIndex) {
        video.muted = true;
        video.preload = 'auto';
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  async function build(appRoot) {
    if (built.has(appRoot) || !appRoot.isConnected) return;
    if (typeof window.Swiper === 'undefined') return;

    const entries = playlist(appRoot);
    if (!entries.length) return;

    const host = appRoot.parentElement;
    if (!host) return;

    built.add(appRoot);

    const handles = Array.from(new Set(entries.map((entry) => entry.handle).filter(Boolean)));
    const fetched = await Promise.all(handles.map(fetchProduct));
    const byHandle = new Map(handles.map((handle, index) => [handle, fetched[index]]));

    if (!appRoot.isConnected) return;
    host.querySelectorAll(':scope > .reelup-carousel').forEach((stale) => stale.remove());
    host.classList.add('reelup-carousel__host');
    appRoot.classList.add('reelup-carousel__source');

    const wrap = document.createElement('div');
    wrap.className = 'reelup-carousel';

    const headingSource = appRoot.querySelector(HEADING);
    if (headingSource && headingSource.textContent.trim()) {
      const heading = document.createElement('p');
      heading.className = 'reelup-carousel__heading';
      heading.textContent = headingSource.textContent.trim();
      wrap.appendChild(heading);
    }

    const container = document.createElement('div');
    container.className = 'swiper reelup-carousel__swiper';
    const track = document.createElement('div');
    track.className = 'swiper-wrapper';
    container.appendChild(track);
    wrap.appendChild(container);

    host.insertBefore(wrap, appRoot);

    container.addEventListener('click', (event) => {
      const control = event.target.closest('.reelup-carousel__cart');
      if (control) {
        if (control.tagName === 'BUTTON') addToCart(control);
        return;
      }

      const slide = event.target.closest('.reelup-carousel__slide');
      if (!slide) return;
      openInApp(appRoot, slide.dataset.reelId);
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const gap = spacing(wrap);
    const looping = entries.length > 2;

    const visible = fitsOnScreen(container, track, gap, wrap);

    const minimum = visible * 2 + 2;
    const rendered =
      looping && entries.length && entries.length < minimum
        ? Array.from({ length: Math.ceil(minimum / entries.length) }, () => entries).flat()
        : entries;

    const shifted = Math.ceil(visible / 2);
    const extra = Math.max(
      1,
      Math.min(visible + 1, rendered.length - visible - shifted - 2)
    );

    rendered.forEach((entry) => {
      const slide = slideMarkup(entry);
      if (entry.handle) attachProduct(slide, byHandle.get(entry.handle));
      track.appendChild(slide);
    });

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'reelup-carousel__nav reelup-carousel__nav--prev swiper-no-swiping';
    prev.setAttribute('aria-label', 'Previous video');
    prev.innerHTML = NAV_ICON;
    const next = prev.cloneNode(true);
    next.className = 'reelup-carousel__nav reelup-carousel__nav--next swiper-no-swiping';
    next.setAttribute('aria-label', 'Next video');
    container.append(prev, next);

    const swiper = new window.Swiper(container, {
      slidesPerView: 'auto',
      centeredSlides: true,

      loop: looping,
      loopAdditionalSlides: extra,

      centeredSlidesBounds: !looping,
      rewind: !looping,
      spaceBetween: gap,
      speed: reduceMotion ? 0 : 500,
      grabCursor: true,

      threshold: 8,
      a11y: { enabled: true },
      keyboard: { enabled: true, onlyInViewport: true },
      navigation: { prevEl: prev, nextEl: next },

      autoplay: reduceMotion
        ? false
        : {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
      on: {
        init: playOnly,
        slideChange: playOnly,
      },
    });

    silence(appRoot);
  }

  function isRendered(appRoot) {
    return appRoot.querySelectorAll(`${CARD}[data-reel-id]`).length > 0;
  }

  function apply() {
    document.querySelectorAll(APP_ROOT).forEach((appRoot) => {
      if (built.has(appRoot)) {
        appRoot.classList.add('reelup-carousel__source');
        if (appRoot.parentElement) appRoot.parentElement.classList.add('reelup-carousel__host');
        silence(appRoot);
        return;
      }
      if (!isRendered(appRoot)) return;
      ensureSwiper()
        .then(() => build(appRoot))
        .catch(() => {});
    });
  }

  function scheduleApply() {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(apply, SETTLE_DELAY);
  }

  function start() {
    apply();
    observer = new MutationObserver(scheduleApply);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }, WATCH_TIMEOUT);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(resize, SETTLE_DELAY);
  });

  document.addEventListener('shopify:section:load', scheduleApply);
})();
